import open from 'open';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { getTestOverrides } from '@wix/cli-test-overrides';
import { open as openTestkit } from './open-testkit.js';

export async function openBrowser(url: string) {
  const { userBrowserTestEndpoint: testEndpoint } = getTestOverrides();

  try {
    if (testEndpoint) {
      await openTestkit(testEndpoint, url);
    } else {
      await open(url, {
        background: true,
      });
    }
  } catch (error) {
    throw new CliError({
      code: CliErrorCode.FailedToOpenBrowser(),
      info: { url },
      cause: error,
    });
  }
}
